'use strict';

var UserManagementManageUsersDeleteModalController = function UserManagementManageUsersDeleteModalController($scope, deleteUserService, userManagementConstants, userManagementDataService, $q, userSecureService) {
  $scope.$on('user-management-manage-users-grid: showDeleteModal', function (event, value) {
    $scope.selectedUser = value;
    refreshGrid();
  });
  $scope.height = 0;
  var columnDefs;
  columnDefs = [{
    headerName: 'Name',
    field: 'userId',
    cellClass: 'ag-cell-center'
  }, {
    headerName: 'Email Address',
    field: 'email',
    cellClass: 'ag-cell-center'
  }, {
    headerName: 'Location',
    field: 'cityCode',
    cellClass: 'ag-cell-center'
  }, {
    headerName: 'Current Role',
    field: 'roles',
    cellClass: 'ag-cell-center'
  }];
  $scope.gridOptions = {
    columnDefs: columnDefs,
    rowData: $scope.selectedUser,
    suppressCellSelection: true,
    rowHeight: 25
  };
  function refreshGrid() {
    var gridOptions = $scope.gridOptions;
    gridOptions.api.setRows($scope.selectedUser);
    $scope.calculateGridHeight(gridOptions.rowData.length);
  }
  function reloadGrid() {
    $scope.$broadcast('grid:dataChanged');
  }
  $scope.calculateGridHeight = function (rows) {
    $scope.height = rows * 25 + 26;
  };
  $scope.approveDelete = function () {
    $q.all({
      deleteUsers: deleteUserService.removeUsers($scope.selectedUser),
      removeUserFromMarkets: userManagementDataService.removeUsersAsMarketOwners($scope.selectedUser)
    }).then(function () {
      userSecureService.refreshUserConfig().then(function () {
        reloadGrid();
        $scope.hideDeleteModal();
        $scope.$emit('user-management-manage-users:change-screen', userManagementConstants.SCREEN_VALUE.MANAGE_USERS);
      });
    });
  };
};
UserManagementManageUsersDeleteModalController.$inject = ['$scope', 'DeleteUserService', 'UserManagementConstants', 'UserManagementDataService', '$q', 'UserSecureService'];
module.exports = UserManagementManageUsersDeleteModalController;